import { smallStore } from 'stores/smallStore/smallStore'

export const closeAlmaChat = () => {
  smallStore.setState((s) => ({
    ...s,
    showAlmaChat: false,
  }))
}
